import { FC } from 'react';

import { PaymentHistory } from '../../components/tariff/payment-history';

export const PaymentHistoryTab: FC = () => {
  return (
    <div className="flex flex-col gap-5">
      <PaymentHistory />
    </div>
  );
};
